
import { PageSEO } from "@/components/PageSEO";
import { Dealer } from "@/types/dealer";
import { 
  createLocalBusinessSchema, 
  createBreadcrumbsSchema 
} from "@/utils/schemaUtils";

interface DealerSEOProps {
  dealer: Dealer;
  formattedCity: string;
  canonicalPath: string;
}

export function DealerSEO({ dealer, formattedCity, canonicalPath }: DealerSEOProps) {
  const city = dealer.city || formattedCity || 'Roma';
  
  // Create local business schema
  const localBusinessSchema = createLocalBusinessSchema({
    name: dealer.name,
    description: `${dealer.name} è un compro oro a ${city} che offre valutazioni e quotazioni in tempo reale per oro, argento e preziosi.`,
    streetAddress: dealer.address,
    city: city,
    region: "RM",
    country: "IT",
    telephone: dealer.phone,
    url: `https://www.gildy.it${canonicalPath}`,
    image: dealer.image_url,
    latitude: dealer.latitude,
    longitude: dealer.longitude,
    openingHours: dealer.opening_hours || "Mo-Fr 09:00-18:00",
    priceRange: "€€",
    rating: dealer.rating,
    reviewCount: 1 // Default to 1 review since review_count is not available
  });
  
  // Create breadcrumbs schema
  const breadcrumbsSchema = createBreadcrumbsSchema([
    { name: 'Home', url: '/' },
    { name: 'Compro Oro', url: '/compro-oro' },
    { name: city, url: `/compro-oro/${city.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-')}` },
    { name: dealer.name, url: canonicalPath }
  ]);
  
  // Keywords for SEO
  const keywords = [
    `compro oro ${city}`, 
    `${dealer.name}`, 
    `vendere oro ${city}`, 
    "valutazione oro", 
    "quotazione oro", 
    "prezzo oro usato",
    "compro argento",
    "valutazione gioielli"
  ];
  
  return (
    <PageSEO
      title={`${dealer.name} - Compro Oro a ${city} - Gildy`}
      description={`${dealer.name}: compro oro a ${city}. Prezzi, valutazioni e quotazioni in tempo reale per oro e argento. Visita il negozio o richiedi una valutazione online.`}
      canonicalPath={canonicalPath}
      structuredData={[localBusinessSchema, breadcrumbsSchema]}
      keywords={keywords}
      ogType="business.business"
    />
  );
}
